import {combineReducers} from "redux";

import banner from "../features/admin/aboutus/banner/Slice";

import visionmission from "../features/admin/aboutus/visionmission/Slice";

import whychooseus from "../features/admin/aboutus/whychooseus/Slice";

import peoplebehindwork from "../features/admin/aboutus/peoplebehindwork/Slice";

import whywerank from "../features/admin/aboutus/whywerank/Slice";

import whatmakedifferent from "../features/admin/aboutus/whatmakedifferent/Slice";

import wefocus from "../features/admin/aboutus/wefocus/Slice";

import whatourcustomersay from "../features/admin/aboutus/whatourcustomersay/Slice";

import manbehindpower from "../features/admin/aboutus/manbehindpower/Slice";

import common from "../features/admin/common/Slice";

const aboutus = combineReducers({
    banner,
    visionmission,
    whychooseus,
    peoplebehindwork,
    whywerank,
    whatmakedifferent,
    wefocus,
    whatourcustomersay,
    manbehindpower,
    common
});

export default aboutus;